import { useCoins } from '@/shared/api';

export const useCoinOptions = (type: 'buy' | 'sell') => {
  const coins = useCoins();

  const nativeCoins = coins.data?.filter(
    (x) => x.slug === 'IQD' || x.slug === 'USDT',
  );
  const allCoins = coins.data;

  return {
    ...coins,
    data: {
      paybale: type === 'buy' ? nativeCoins : allCoins,
      receivable: type === 'buy' ? allCoins : nativeCoins,
    },
  };
};
